/* ==========================================================================
   gg-popup.js — GelGun e-mail capture popup
   Behaviour only. All tunables come from the #gg-popup-settings JSON block,
   which Olda-connector/popup.py generates from Claude/POPUP-CONFIG.md.

   Submits the native Shopify customer form over fetch so the page never
   reloads. Shopify itself is the deduplicator: an address that is already
   SUBSCRIBED keeps its consent timestamp, no duplicate customer is created,
   and the Shopify Email welcome automation does not fire a second time.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.getElementById('gg-popup');
  if (!root) return;

  var DEFAULTS = {
    storageKey: 'gg_popup_v1',
    scrollPercent: 10,
    fallbackDelayMs: 6000,
    maxPerDay: 2,
    oncePerSession: true,
    reappearAfterDismissHours: 0,
    analytics: true,
    eventPrefix: 'gg_popup',
    checkEndpoint: '',
    tabEnabled: false,
    tabDelayMs: 600,
    tabCollapseAfterMs: 0,
    tabDismissDays: 0
  };

  var cfg = {};
  for (var d in DEFAULTS) { cfg[d] = DEFAULTS[d]; }
  cfg.text = {};
  try {
    var raw = document.getElementById('gg-popup-settings');
    if (raw && raw.textContent.trim()) {
      var parsed = JSON.parse(raw.textContent);
      for (var k in DEFAULTS) { if (parsed[k] !== undefined) cfg[k] = parsed[k]; }
      cfg.text = parsed.text || {};
    }
  } catch (e) { /* keep defaults */ }

  var card = root.querySelector('.gg-popup__card');
  var form = root.querySelector('#gg-popup-form');
  var email = root.querySelector('#gg-popup-email');
  var consent = root.querySelector('#gg-popup-consent');
  var honey = root.querySelector('#gg-popup-hp');
  var errorEl = root.querySelector('#gg-popup-error');
  var submitBtn = root.querySelector('[data-gg-submit]');
  var spinner = root.querySelector('[data-gg-spinner]');
  var panes = {
    form: root.querySelector('[data-gg-pane="form"]'),
    known: root.querySelector('[data-gg-pane="known"]'),
    success: root.querySelector('[data-gg-pane="success"]')
  };

  var tabEl = document.getElementById('gg-popup-tab');
  var tabOpenBtn = tabEl && tabEl.querySelector('[data-gg-tab-open]');
  var tabCloseBtn = tabEl && tabEl.querySelector('[data-gg-tab-x]');

  var params = new URLSearchParams(window.location.search);
  var forceShow = params.get('gg-popup') === '1';
  var forceTab = params.get('gg-popup-tab') === '1';
  var resetState = params.get('gg-popup-reset') === '1';
  var isOpen = false;
  var lastFocus = null;
  var armed = false;

  /* ---------- state ------------------------------------------------------ */

  function today() {
    var d = new Date();
    return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
  }

  // Private mode, blocked cookies and some in-app webviews make localStorage
  // throw. Falling back to {} would drop every cap and turn this into a
  // pop-on-every-page, so an in-memory copy backs it up for the tab's lifetime.
  var memState = null;
  var memSession = false;

  var SESSION_KEY = 'gg_popup_shown_session';

  function shownThisSession() {
    try {
      if (window.sessionStorage.getItem(SESSION_KEY)) return true;
    } catch (e) { /* fall through to memory */ }
    return memSession;
  }

  function markShownThisSession() {
    memSession = true;
    try { window.sessionStorage.setItem(SESSION_KEY, '1'); } catch (e) { /* memory only */ }
  }

  function readState() {
    try {
      var s = JSON.parse(window.localStorage.getItem(cfg.storageKey) || '{}');
      if (typeof s === 'object' && s !== null) return s;
    } catch (e) { /* fall through to memory */ }
    return memState || {};
  }

  function writeState(s) {
    memState = s;
    try { window.localStorage.setItem(cfg.storageKey, JSON.stringify(s)); } catch (e) { /* memory only */ }
  }

  if (resetState) {
    try { window.localStorage.removeItem(cfg.storageKey); } catch (e) {}
    try { window.sessionStorage.removeItem('gg_popup_shown_session'); } catch (e) {}
    try { window.sessionStorage.removeItem('gg_popup_pending'); } catch (e) {}
    try { window.sessionStorage.removeItem('gg_popup_tab_session'); } catch (e) {}
    try { window.sessionStorage.removeItem('gg_popup_tab_off'); } catch (e) {}
  }

  /* ---------- telemetry -------------------------------------------------- */

  function track(name, extra) {
    if (!cfg.analytics) return;
    var evt = cfg.eventPrefix + '_' + name;
    var payload = { event: evt, popup_id: 'gg-popup-10' };
    if (extra) { for (var k in extra) payload[k] = extra[k]; }
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
    } catch (e) {}
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', evt, { popup_id: 'gg-popup-10' });
      }
    } catch (e) {}
  }

  /* ---------- eligibility ------------------------------------------------ */

  function mayShow() {
    if (forceShow) return true;
    var s = readState();
    if (s.sub) return false;

    // once per browsing session, no time gap — Dominik's call 2026-09-04
    if (cfg.oncePerSession && shownThisSession()) return false;

    var now = Date.now();
    if (cfg.reappearAfterDismissHours > 0 && s.dis) {
      if (now - s.dis < cfg.reappearAfterDismissHours * 3600000) return false;
    }
    if (cfg.maxPerDay > 0 && s.day === today() && (s.n || 0) >= cfg.maxPerDay) return false;
    return true;
  }

  function countShow() {
    markShownThisSession();
    var s = readState();
    if (s.day !== today()) { s.day = today(); s.n = 0; }
    s.n = (s.n || 0) + 1;
    s.last = Date.now();
    writeState(s);
  }

  /**
   * Cheap non-cryptographic hash. Enough to answer "is this the same address
   * as last time" without keeping anyone's e-mail in plain text in a browser
   * that might be shared.
   */
  function fingerprint(address) {
    var h = 5381;
    var str = String(address || '').trim().toLowerCase();
    for (var i = 0; i < str.length; i++) h = ((h << 5) + h + str.charCodeAt(i)) | 0;
    return String(h >>> 0);
  }

  function markSubscribed(address) {
    var s = readState();
    s.sub = 1;
    s.subAt = Date.now();
    if (address) s.subFp = fingerprint(address);
    writeState(s);
    hideTab();
  }

  // Stashed just before the native submit, promoted to state on the way back.
  // Without it the confirmation page has no idea which address was sent, so a
  // second attempt with the same address could not be recognised locally.
  var PENDING_KEY = 'gg_popup_pending';

  function setPending(address) {
    try { window.sessionStorage.setItem(PENDING_KEY, fingerprint(address)); } catch (e) { /* ignore */ }
  }

  function takePending() {
    try {
      var v = window.sessionStorage.getItem(PENDING_KEY);
      window.sessionStorage.removeItem(PENDING_KEY);
      return v;
    } catch (e) { return null; }
  }

  /* ---------- open / close ---------------------------------------------- */

  function focusables() {
    return Array.prototype.filter.call(
      card.querySelectorAll('button, [href], input:not([type="hidden"]), select, textarea'),
      function (el) { return !el.disabled && el.offsetParent !== null; }
    );
  }

  function onKeydown(e) {
    if (e.key === 'Escape') { close('esc'); return; }
    if (e.key !== 'Tab') return;
    var list = focusables();
    if (!list.length) return;
    var first = list[0];
    var last = list[list.length - 1];
    var active = document.activeElement;
    // open() focuses the card itself, which is tabindex="-1" and so not in the
    // list — without this branch the first Shift+Tab escaped the dialog and the
    // trap never re-engaged
    if (!card.contains(active) || active === card) {
      e.preventDefault();
      (e.shiftKey ? last : first).focus();
      return;
    }
    if (e.shiftKey && active === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && active === last) { e.preventDefault(); first.focus(); }
  }

  function open(pane, source) {
    if (isOpen) return;
    isOpen = true;
    hideTab();
    lastFocus = document.activeElement;
    showPane(pane || 'form');
    root.hidden = false;
    document.documentElement.classList.add('gg-popup-open');
    document.addEventListener('keydown', onKeydown, true);
    // focus the dialog, not the field: focusing an input pops the mobile keyboard
    card.setAttribute('tabindex', '-1');
    card.focus({ preventScroll: true });
    // a forced preview (?gg-popup=1) is not an impression: counting it would
    // burn one of the visitor's two daily slots and push a fake GA4 view
    if ((pane || 'form') === 'form' && !forceShow) {
      // Nor is an open the visitor asked for by clicking the corner tab. It is
      // not shown to them, they went and got it — counting it as an impression
      // would flatter the popup's conversion rate and eat a daily slot the
      // popup itself never used. It reports as gg_popup_tab_open instead.
      if (source === 'tab') { track('tab_open'); }
      else { countShow(); track('view'); }
    }
  }

  function close(reason) {
    if (!isOpen) return;
    isOpen = false;
    root.hidden = true;
    document.documentElement.classList.remove('gg-popup-open');
    document.removeEventListener('keydown', onKeydown, true);
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
    if (reason !== 'success') {
      var s = readState();
      s.dis = Date.now();
      writeState(s);
      track('dismiss', { reason: reason || 'close' });
      // closed without subscribing -> the corner tab is the second chance
      armTabForSession();
      if (mayShowTab()) showTab(cfg.tabDelayMs);
    }
  }

  function showPane(name) {
    for (var key in panes) { if (panes[key]) panes[key].hidden = key !== name; }
    // hiding the pane that held focus drops it to <body> and the new heading is
    // never announced, so move it explicitly
    var pane = panes[name];
    if (pane && isOpen) {
      var target = pane.querySelector('[data-gg-focus]') || pane;
      try { target.focus({ preventScroll: true }); } catch (e) { /* older browsers */ }
    }
  }

  Array.prototype.forEach.call(root.querySelectorAll('[data-gg-close]'), function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      // closing the success pane is not a dismissal — they subscribed
      if (panes.success && !panes.success.hidden) { close('success'); return; }
      close(el.classList.contains('gg-popup__backdrop') ? 'backdrop' : 'button');
    });
  });

  /* ---------- corner tab -------------------------------------------------
     The second chance. Shown only after the popup has been closed without a
     signup, and only for the rest of that browsing session — a new session
     brings the popup itself back, which is the offer's real entry point.

     Everything the popup is gated on server-side gates this too, because the
     markup only exists when those gates pass. What is left to decide here is
     the same three things the popup decides: subscribed already, dismissed
     already, or not this session.
     ---------------------------------------------------------------------- */

  var TAB_SESSION_KEY = 'gg_popup_tab_session';
  var TAB_OFF_KEY = 'gg_popup_tab_off';
  var memTabSession = false;   // storage can throw; the caps must survive it
  var memTabOff = false;
  var tabTimer = null;
  var tabCollapseTimer = null;
  var tabVisible = false;

  /**
   * Collapsing to the badge is desktop-only. On touch there is no hover, so a
   * collapsed pill could never be expanded again and its close button would be
   * unreachable — the visitor would be stuck with a dot they cannot dismiss.
   */
  function canHover() {
    try { return window.matchMedia('(hover: hover)').matches; } catch (e) { return true; }
  }

  function tabArmedThisSession() {
    if (memTabSession) return true;
    try { return !!window.sessionStorage.getItem(TAB_SESSION_KEY); } catch (e) { return false; }
  }

  function armTabForSession() {
    memTabSession = true;
    try { window.sessionStorage.setItem(TAB_SESSION_KEY, '1'); } catch (e) { /* memory only */ }
  }

  function tabDismissed() {
    if (memTabOff) return true;
    try { if (window.sessionStorage.getItem(TAB_OFF_KEY)) return true; } catch (e) { /* memory only */ }
    if (cfg.tabDismissDays > 0) {
      var s = readState();
      if (s.tabDis && Date.now() - s.tabDis < cfg.tabDismissDays * 86400000) return true;
    }
    return false;
  }

  function mayShowTab() {
    if (!tabEl || !cfg.tabEnabled) return false;
    if (forceTab) return true;
    if (readState().sub) return false;
    if (tabDismissed()) return false;
    return tabArmedThisSession();
  }

  /**
   * The delay is deliberate. Appearing the instant the popup closes reads as
   * the popup sliding into the corner — the same thing, still there — rather
   * than an offer that stepped out of the way and left a door open.
   */
  function showTab(delayMs) {
    if (!tabEl || tabVisible || isOpen) return;
    if (tabTimer) window.clearTimeout(tabTimer);
    tabTimer = window.setTimeout(function () {
      tabTimer = null;
      if (isOpen || !mayShowTab()) return;
      tabVisible = true;
      tabEl.classList.remove('is-collapsed');
      tabEl.hidden = false;
      track('tab_view');
      if (cfg.tabCollapseAfterMs > 0 && canHover()) {
        tabCollapseTimer = window.setTimeout(function () {
          tabCollapseTimer = null;
          if (tabVisible) tabEl.classList.add('is-collapsed');
        }, cfg.tabCollapseAfterMs);
      }
    }, delayMs || 0);
  }

  function hideTab() {
    if (!tabEl) return;
    tabVisible = false;
    tabEl.hidden = true;
    if (tabTimer) { window.clearTimeout(tabTimer); tabTimer = null; }
    if (tabCollapseTimer) { window.clearTimeout(tabCollapseTimer); tabCollapseTimer = null; }
  }

  function dismissTab() {
    hideTab();
    memTabOff = true;
    try { window.sessionStorage.setItem(TAB_OFF_KEY, '1'); } catch (e) { /* memory only */ }
    if (cfg.tabDismissDays > 0) {
      var s = readState();
      s.tabDis = Date.now();
      writeState(s);
    }
    track('tab_dismiss');
  }

  if (tabOpenBtn) {
    tabOpenBtn.addEventListener('click', function () {
      track('tab_click');
      open('form', 'tab');
    });
  }
  if (tabCloseBtn) {
    tabCloseBtn.addEventListener('click', function (ev) {
      // the pill is not itself clickable, but stop it reaching anything the
      // theme may have bound further up
      ev.stopPropagation();
      dismissTab();
    });
  }

  /* ---------- submit ----------------------------------------------------- */

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function fail(msg) {
    if (!errorEl) return;
    errorEl.textContent = msg;
    errorEl.hidden = false;
    if (email) email.setAttribute('aria-invalid', 'true');
  }

  function clearFail() {
    if (!errorEl) return;
    errorEl.hidden = true;
    errorEl.textContent = '';
    if (email) email.removeAttribute('aria-invalid');
  }

  function busy(on) {
    if (submitBtn) submitBtn.disabled = on;
    if (spinner) spinner.hidden = !on;
  }

  function t(key, fallbackText) {
    return (cfg.text && cfg.text[key]) || fallbackText;
  }

  /* ---------- the endpoint ------------------------------------------------ */

  function apiUrl(path) {
    if (!cfg.checkEndpoint) return null;
    return String(cfg.checkEndpoint).replace(/\/+$/, '') + path;
  }

  function ask(path, options, timeoutMs) {
    var url = apiUrl(path);
    if (!url) return Promise.resolve(null);
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = controller ? window.setTimeout(function () { controller.abort(); }, timeoutMs) : null;
    var init = { headers: { Accept: 'application/json' }, signal: controller ? controller.signal : undefined };
    for (var k in (options || {})) init[k] = options[k];
    return fetch(url, init)
      .then(function (res) { return res.json().catch(function () { return null; }); })
      .catch(function () { return null; })
      .then(function (body) {
        if (timer) window.clearTimeout(timer);
        return body;
      });
  }

  /**
   * Prefetched answer to "is this address already subscribed?", cached per
   * address. Only used to skip the round trip on submit; the signup call makes
   * the same decision server-side, so losing the prefetch race costs nothing.
   */
  var checkCache = {};

  function checkAlreadySubscribed(address) {
    var key = address.toLowerCase();
    if (checkCache[key] !== undefined) return Promise.resolve(checkCache[key]);
    return ask('/check?email=' + encodeURIComponent(address), { method: 'GET' }, 4000)
      .then(function (body) {
        var status = body && body.status ? body.status : null;
        checkCache[key] = status;
        return status;
      });
  }

  function subscribe(address) {
    return ask('/subscribe', {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: address }),
    }, 12000);
  }

  /* ---------- submit ------------------------------------------------------ */

  var submitting = false;

  if (form) {
    if (email) {
      // Prefetch while they are still typing, purely to make the click feel
      // instant. Not load-bearing any more: /subscribe decides server-side.
      var prefetchTimer = null;

      function prefetch() {
        var address = (email.value || '').trim();
        if (cfg.checkEndpoint && EMAIL_RE.test(address)) checkAlreadySubscribed(address);
      }

      email.addEventListener('input', function () {
        clearFail();
        if (prefetchTimer) window.clearTimeout(prefetchTimer);
        prefetchTimer = window.setTimeout(prefetch, 350);
      });
      email.addEventListener('change', prefetch);
      email.addEventListener('blur', prefetch);
      if (submitBtn) submitBtn.addEventListener('pointerdown', prefetch);
    }

    /**
     * The signup goes to the Worker, not to /contact.
     *
     * Shopify's spam protection for customer forms rejects a fetch with 400
     * "Missing CAPTCHA token", and for a low-trust session it redirects to a
     * full-page hCaptcha challenge — real customers in incognito were landing
     * on it (reported 6 Sep 2026). It also owns the submit once it starts, so
     * preventDefault cannot call it off. Going through the Admin API, which is
     * what the app this replaces did, removes the challenge, the page reload
     * and the check race together.
     *
     * The form markup stays for the no-JS case: without JS it submits natively
     * to /contact and the ?customer_posted=true branch in arm() confirms it.
     */
    // set only by the no-endpoint fallback, so the one native submit it needs
    // is not intercepted by our own handler
    var passThrough = false;

    function handleIntent(ev) {
      if (passThrough) return;
      if (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        if (ev.stopImmediatePropagation) ev.stopImmediatePropagation();
      }
      if (submitting) return;
      clearFail();

      var value = (email && email.value || '').trim();
      if (!EMAIL_RE.test(value)) {
        fail(t('errInvalid', 'Zkontroluj prosím e-mailovou adresu.'));
        if (email) email.focus();
        return;
      }
      if (consent && !consent.checked) {
        fail(t('errConsent', 'Bez souhlasu ti slevu nemůžeme poslat.'));
        consent.focus();
        return;
      }
      // honeypot: a bot fills the hidden field. Autofill can too, so only treat
      // it as a bot when it disagrees with the real address.
      if (honey && honey.value && honey.value.trim().toLowerCase() !== value.toLowerCase()) {
        showPane('success');
        return;
      }
      // this browser already signed this exact address up — instant, offline
      var localState = readState();
      if (localState.subFp && localState.subFp === fingerprint(value)) {
        showPane('known');
        track('already_subscribed', { source: 'local' });
        return;
      }
      // the prefetch already told us
      if (checkCache[value.toLowerCase()] === 'subscribed') {
        showPane('known');
        markSubscribed(value);
        track('already_subscribed', { source: 'endpoint' });
        return;
      }

      if (!cfg.checkEndpoint) {
        // No endpoint configured: fall back to the theme's own form, captcha
        // and page reload included. Better than silently doing nothing.
        if (email) email.value = value;
        setPending(value);
        busy(true);
        track('submit');
        passThrough = true;
        // requestSubmit, not submit(): it fires a real submit event, which is
        // what lets Shopify's captcha script attach its token
        if (form.requestSubmit) { form.requestSubmit(submitBtn || undefined); } else { form.submit(); }
        return;
      }

      submitting = true;
      busy(true);
      track('submit');

      subscribe(value).then(function (body) {
        submitting = false;
        busy(false);
        var status = body && body.status;

        if (status === 'already') {
          showPane('known');
          markSubscribed(value);
          track('already_subscribed', { source: 'endpoint' });
          return;
        }
        if (status === 'created' || status === 'resubscribed') {
          showPane('success');
          markSubscribed(value);
          track('success', { status: status });
          return;
        }
        fail(t('errServer', 'Něco se nepovedlo. Zkus to prosím ještě raz nebo napiš na info@gel-gun.cz.'));
        track('error', { message: (body && (body.error || body.status)) || 'no_response' });
      });
    }

    document.addEventListener('click', function (ev) {
      if (!isOpen || !ev.target || !ev.target.closest) return;
      if (!ev.target.closest('#gg-popup-form')) return;
      var btn = ev.target.closest('button, input[type="submit"]');
      if (!btn || btn.type !== 'submit') return;
      handleIntent(ev);
    }, true);

    // Enter in the field submits implicitly. Caught on document capture so it
    // runs before any listener Shopify's captcha script attaches to the form.
    document.addEventListener('keydown', function (ev) {
      if (!isOpen || ev.key !== 'Enter' || !ev.target || !ev.target.closest) return;
      if (!ev.target.closest('#gg-popup-form')) return;
      if (ev.target.tagName === 'BUTTON') return; // the click path owns that
      handleIntent(ev);
    }, true);

    form.addEventListener('submit', handleIntent, true);
  }

  /* ---------- trigger ---------------------------------------------------- */

  function scrolledFraction() {
    var doc = document.documentElement;
    var scrollable = (doc.scrollHeight || 0) - window.innerHeight;
    if (scrollable <= 0) return null; // page does not scroll
    return (window.scrollY || doc.scrollTop || 0) / scrollable;
  }

  function arm() {
    if (armed) return;
    armed = true;

    // a form already posted without JS (no-fetch fallback): confirm and stop
    // Shopify redirected back here with ?customer_posted=true, so the signup
    // went through. This is the success path, not a fallback.
    if (root.querySelector('[data-gg-posted]')) {
      var pending = takePending();
      var st = readState();
      st.sub = 1;
      st.subAt = Date.now();
      if (pending) st.subFp = pending;
      writeState(st);
      open('success');
      track('success');
      // drop ?customer_posted=true so a refresh or a shared link does not
      // replay the confirmation
      try {
        if (window.history && window.history.replaceState) {
          var clean = new URL(window.location.href);
          clean.searchParams.delete('customer_posted');
          clean.hash = '';
          window.history.replaceState({}, '', clean.pathname + (clean.search || ''));
        }
      } catch (e) { /* cosmetic only */ }
      return;
    }

    // Later page views in the same session: the popup is done (once per
    // session) but the tab carries the offer. Checked before mayShow(), which
    // returns false for exactly that visitor.
    if (mayShowTab()) showTab(cfg.tabDelayMs);

    if (!mayShow()) return;

    if (forceShow) { open('form'); return; }

    var fired = false;
    function maybeFire() {
      if (fired) return;
      var frac = scrolledFraction();
      if (frac === null) return;
      if (frac * 100 >= cfg.scrollPercent) {
        fired = true;
        window.removeEventListener('scroll', onScroll);
        if (mayShow()) open('form');
      }
    }
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { ticking = false; maybeFire(); });
    }
    window.addEventListener('scroll', onScroll, { passive: true });

    // Time fallback, whichever comes first. 10% of a long page is ~640px, so a
    // visitor who skims the hero and clicks straight into a product never
    // crosses the scroll threshold — that is how the popup "doesn't work" while
    // working exactly as specified. It also covers pages too short to scroll.
    // fallback_delay_ms: 0 turns this off and makes it scroll-only.
    if (cfg.fallbackDelayMs > 0) {
      window.setTimeout(function () {
        if (fired) return;
        fired = true;
        window.removeEventListener('scroll', onScroll);
        if (mayShow()) open('form');
      }, cfg.fallbackDelayMs);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arm);
  } else {
    arm();
  }

  // small handle for manual checks from the console
  window.ggPopup = {
    open: function () { open('form'); },
    close: function () { close('manual'); },
    state: readState,
    // what the check endpoint has said so far, for debugging from the console
    checked: function (address) {
      return address ? checkCache[String(address).toLowerCase()] : checkCache;
    },
    showTab: function () { armTabForSession(); showTab(0); },
    hideTab: hideTab,
    tabState: function () {
      return { visible: tabVisible, armed: tabArmedThisSession(), dismissed: tabDismissed(), mayShow: mayShowTab() };
    },
    reset: function () {
      memState = null;
      memSession = false;
      memTabSession = false;
      memTabOff = false;
      hideTab();
      try { window.localStorage.removeItem(cfg.storageKey); } catch (e) {}
      try { window.sessionStorage.removeItem(SESSION_KEY); } catch (e) {}
      try { window.sessionStorage.removeItem(PENDING_KEY); } catch (e) {}
      try { window.sessionStorage.removeItem(TAB_SESSION_KEY); } catch (e) {}
      try { window.sessionStorage.removeItem(TAB_OFF_KEY); } catch (e) {}
    },
    config: cfg
  };
})();
